import { render, staticRenderFns } from "./Wien.vue?vue&type=template&id=d97b40b0&"
import script from "./Wien.vue?vue&type=script&lang=js&"
export * from "./Wien.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports